// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `:host{display:inline-block}.status{display:inline-flex;align-items:center;gap:1ex}.status__icon{font-size:var(--uap-font-size--body-small)}.status__count{font-weight:500}.tooltip-nowrap{white-space:nowrap}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
